import { Auth } from '../common/auth';
import { axiosPublic } from './common/axiosPublic';
import { handleResponse, handleError } from '../../helpers/network';

export const login = async (email, password) => {
    const data = { email, password };
    return axiosPublic.post(`/auth/login`, data).then(handleResponse).catch(handleError);
};

export const register = async (data) => {
    return axiosPublic.post(`/auth/register`, data).then(handleResponse).catch(handleError);
};

export const renew = async () => {
    const refreshToken = Auth.getRefreshToken();
    const data = { refreshToken };
    return axiosPublic.post(`/auth/renew`, data).then(handleResponse).catch(handleError);
};
